import { useRouter } from "next/router";
import React from "react";
import { useIntl } from "react-intl";

import {
  BookingFormProps,
  useBookingForm,
} from "shared/hooks/bookingForm/bookingForm";

import LoaderMini from "@components/UI/LoaderMini";

import BookingFormPaymentDefinition from "./BookingFormPaymentDefinition";
import BookingFormSection from "./BookingFormSection";

function BookingForm(props: BookingFormProps) {
  const { refs, fullPrice, isFlight, isHotel } = props;

  const router = useRouter();
  const intl = useIntl();

  const { bookingFormSections, isBookingFormReady } = useBookingForm({
    refs,
    fullPrice,
    query: router.query,
    intl,
    isFlight,
    isHotel,
  });

  if (!isBookingFormReady || !bookingFormSections) {
    return (
      <div className="results-booking-form-loader">
        <LoaderMini />
      </div>
    );
  }

  return (
    <div>
      {bookingFormSections.map((bookingFormSection, index) => {
        if (bookingFormSection.type === "PAYMENT") {
          return (
            <BookingFormPaymentDefinition key="PAYMENT" fullPrice={fullPrice} />
          );
        }

        return (
          <BookingFormSection
            index={index}
            key={bookingFormSection.elements.join("")}
          />
        );
      })}
    </div>
  );
}

export default React.memo(BookingForm, (props, nextProps) => {
  if (
    props.refs === nextProps.refs &&
    props.fullPrice === nextProps.fullPrice
  ) {
    // return true if you don't need re-render
    return true;
  }

  return false;
});
